import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { differenceInDays } from "date-fns";
import {
  //   getEmployeeListPersonsListed,
  setTheEmployeeRangetwo,
  setTheEmployeeRangeOne,
  setUserDeleteActions,
  setTheProfileSignatureActions,
  setClientBranchSearchAction,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  SetTheDashboardClientList,
  settheEmployeeActionState,
  settheEmployeeActionRegion,
  settheEmployeeActionZone,
  setTheEmpoyeeAction_branch,
  SetTheBlacklistEditsActions,
  resetUnblockActions_opretions,
  setTablePositionPersist,
  settheEmployee_actions_block_request,
  setthe_employeee_actions_forEmployee_filter,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import _ from "lodash";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import useDebouncedEffect from "use-debounced-effect";
import { Employee_edit } from "./Employee_edit";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import BlockImage from "../../../Assets/AppComponent/Overall_icons/Block_icons_final.svg";
import Swal from "sweetalert2";

const EmployeeActions = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const Swal = require("sweetalert2");
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  var st = convert(state.EmployeeVerificationsNeed.EmployeeRangeOne);
  var et = convert(state.EmployeeVerificationsNeed.EmployeeRangeTwo);

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.EmployeeRangeOne == "" ? [] : [st, et],
  );
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.EmployeeActions?.page == undefined
      ? 1
      : TablePositionPersist.EmployeeActions.page,
  );
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState(
    TablePositionPersist?.EmployeeActions?.search == "" ||
      TablePositionPersist?.EmployeeActions?.search == undefined
      ? ""
      : TablePositionPersist.EmployeeActions.search,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [OldEmp, setOldEMp] = useState(
    state?.EmployeeVerificationsNeed?.Employee_actions_Employee_filter_old_new
      ? state?.EmployeeVerificationsNeed
        ?.Employee_actions_Employee_filter_old_new
      : {
        label: "NEW EMPLOYEE",
        value: false,
      },
  );
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [nameList4, setOptions4] = useState([]);

  const [datas, setData] = useState({
    // zone: state.EmployeeVerificationsNeed?.EmployeeActionZone?.value?.value || '',
    // state: state.EmployeeVerificationsNeed?.EmployeeActionsState?.value?.value || '',
    // region: state.EmployeeVerificationsNeed?.EmployeeActionRegion?.value?.value || ''
    state: state.EmployeeVerificationsNeed.EmployeeActionsState?.value,
    zone: state.EmployeeVerificationsNeed?.EmployeeActionZone?.value,

    region: state.EmployeeVerificationsNeed.EmployeeActionRegion?.value,
  });

  const [records, setrecords] = useState(null);
  const [EditPopup, seteditpopup] = useState(false);
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [nameList5, setOptions5] = useState([]);

  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionsState,
  );
  const [multiselect1, setMuliselect1] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionRegion,
  );
  const [multiselect3, setMuliselect3] = useState(
    state.EmployeeVerificationsNeed.EmployeeActionZone,
  );
  const [searchBranch, setSearch] = useState("");
  const [Client, setClients] = useState(
    state.EmployeeVerificationsNeed.EmployeeAction_Branch?.value?.value,
  );

  const oldemloyeeOptions = [
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];

  const Block_lists = [
    {
      value: true,
      label: "BLOCKED EMPLOYEES",
    },
  ];
  const [BlockEmp, setBlockEMp] = useState(
    state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions
      ? state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions
      : {
        label: "",
        value: "",
      },
  );
  const [Block_request, setblockrequesr] = useState({
    black_list: state?.EmployeeVerificationsNeed
      ?.Block_request_Options_emp_actions?.value
      ? state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions
        ?.value
      : "",
  });

  const [oldemplo, setoldemp] = useState({
    old_employee: state?.EmployeeVerificationsNeed
      ?.Employee_actions_Employee_filter_old_new
      ? state?.EmployeeVerificationsNeed
        ?.Employee_actions_Employee_filter_old_new?.value
      : false,
  });

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheEmployeeRangeOne(range[0]));
      dispatch(setTheEmployeeRangetwo(range[1]));
    } else {
      dispatch(setTheEmployeeRangeOne(""));
      dispatch(setTheEmployeeRangetwo(""));
    }
  }, [range]);

  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
      client: "",
      month: "",
      year: "",
    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [searchBranch, datas]);
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
            ? `${element.branch_code}-${element.client_name.toUpperCase()}`
            : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);

  useEffect(() => {
    // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      // from_date: range[0],
      // to_date: range[1],
      // range: true,
      old_employee: oldemplo.old_employee,
      state: datas.state,
      region: datas.region,
      zone: datas.zone,
      client: Client,
      black_list: Block_request?.black_list,
      is_reliever: "false",
    };
    // if (
    //   state.ProfileSignatureCalls.ProfileSignatureDatas.length == 0 ||
    //   TablePositionPersist?.EmployeeActions?.page != dtpageindex ||
    //   TablePositionPersist?.EmployeeActions?.search != search ||
    //   TablePositionPersist?.EmployeeActions?.old_employee != oldemplo.old_employee ||
    //   TablePositionPersist?.EmployeeActions?.client != Client ||
    //   TablePositionPersist?.EmployeeActions?.zone != datas.zone ||
    //   TablePositionPersist?.EmployeeActions?.region != datas.region ||
    //   TablePositionPersist?.EmployeeActions?.state != datas.state ||
    //         TablePositionPersist?.EmployeeActions?.black_list != Block_request?.black_list

    //   // apiTriggerCount == true
    // ) {
    //   dispatch(getEmployeeListPersonsListed(payloads));
    dispatch(setTheProfileSignatureActions(payloads)); ///for listout the employeee

    dispatch(
      setTablePositionPersist({ data: payloads, pageName: "EmployeeActions" }),
    );
    // }
    currentRef.current.scrollTop = sessionStorage.getItem(
      "EmployeeActionsPageTableScrollPosition",
    );
  }, [search, dtpageindex, oldemplo, datas, Client, Block_request]);

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const columns = [
    {
      Header: "Tnx Id",
      accessor: "",
      Cell: (row) => {
        if (row.row.original.id != undefined && row.row.original.id != null) {
          const userId = row.row.original.id;
          const lastFourDigits = userId.slice(-6);
          return <p className="m-0">{lastFourDigits}</p>;
        }
      },
    },
    // {
    //   Header: "U-ID",
    //   accessor: "user_id.local_uid",
    //   Cell: ({ row }) => {
    //     const userId = row.original?.user_id?.local_uid;

    //     // Handle null, undefined, empty string, or whitespace
    //     const displayValue =
    //       userId == null || String(userId).trim() == "" ? "--" : userId;

    //     return <p className="PTAGs">{displayValue}</p>;
    //   },
    // },

    // oldemplo.old_employee &&
    {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                    row.row.original.user_id?.user_uid != undefined &&
                    row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p
              className="PTAGs"
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`${formattedTime}`}
            >
              {`${row.row.original.created_at.slice(0, 10)}`}
            </p>
          </>
        );
      },
    },

    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <div
              className="UserName"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              style={{ position: "relative" }} // Ensure the tooltip is positioned correctly
            >
              {row.row.original.user_id != null &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != "" &&
                row.row.original.user_id.first_name != null &&
                row.row.original.user_id.first_name != undefined &&
                row.row.original.user_id.first_name != "" ? (
                <div className="">
                  <span

                  // data-tooltip-id="list-ToolTips"
                  // data-tooltip-content={row.row.original.user_id.first_name}
                  >
                    {row.row.original.user_id.first_name.length > 14 ? (
                      <>
                        {capitalizeFirstLetter(
                          row.row.original.user_id.first_name.slice(0, 13),
                        )}
                        ...
                      </>
                    ) : (
                      <>
                        {capitalizeFirstLetter(
                          row.row.original.user_id.first_name,
                        )}
                      </>
                    )}
                  </span>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_id.first_name}
                    </div>
                  )}
                </div>
              ) : (
                <>--</>
              )}
            </div>
          </>
        );
      },
    },

    {
      Header: "Mobile",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id != null &&
              row.row.original.user_id.phone_number != null &&
              row.row.original.user_id.phone_number != "" &&
              row.row.original.user_id.phone_number != undefined ? (
              <>
                {row.row.original.user_id.phone_number != undefined ? (
                  <div className="UserName MobileNumber">
                    <span>{row.row.original.user_id.phone_number}</span>
                  </div>
                ) : (
                  <div className="UserName MobileNumber">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName MobileNumber">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Aadhaar Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.aadhar_number != null &&
              row.row.original.aadhar_number != undefined &&
              row.row.original.aadhar_number != "" &&
              row.row.original.aadhar_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.aadhar_number
                  ? localStorage.getItem("aadharAccess") === "true"
                    ? `**** ****  ${row.row.original.aadhar_number.slice(-4)}`
                    : row.row.original.aadhar_number
                  : ""}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "Pan Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.pan_number != null &&
              row.row.original.pan_number != undefined &&
              row.row.original.pan_number != "" &&
              row.row.original.pan_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.pan_number}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Account Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_number != null &&
              row.row.original.account_number != undefined &&
              row.row.original.account_number != "" &&
              row.row.original.account_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.account_number}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    //           {
    //             Header: "Zone",
    //             accessor: "",
    //             Cell: (row) => {
    //               return (
    //                 <>
    //                   {row.row.original.user_id != null &&
    //                   row.row.original.user_id.zone_id != null &&
    //                   row.row.original.user_id.zone_id != undefined ? (
    //                     <>
    //                       {row.row.original.user_id.zone_id != undefined  && row.row.original.user_id.zone_id.length > 0 ? (
    //                         <div className="UserName">
    //                           <span

    //                           >
    //                             {/* {row.row.original.user_id.zone_id.zone_name} */}

    //                             {row.row.original.user_id.zone_id.map((item) => {
    //                                console.log(item ,"203912309item",item.zone_name);

    //                               return <>{item.zone_name != "" && item.zone_name != null &&item.zone_name.length > 10 ?

    //   <p
    //   data-tooltip-id="list-ToolTips"
    //   data-tooltip-content={item.zone_name}
    //    className="MobileNumber"
    //   >{item.zone_name.slice(0,8)}</p>
    //   :

    //   <>
    //   {item.zone_name != null && item.zone_name !="" ?
    //   <p                               data-tooltip-id="list-ToolTips"
    //    className="MobileNumber"
    //                                 data-tooltip-content={item.zone_name}>{item.zone_name}</p>
    //   : <>---</> }
    // </>

    //                               }</>;
    //                             }
    //                             )}
    //                           </span>
    //                         </div>
    //                       ) : (
    //                         <div className="UserName MobileNumber">
    //                           <span>---</span>
    //                         </div>
    //                       )}
    //                     </>
    //                   ) : (
    //                     <div className="UserName MobileNumber">
    //                       <span>{"----"}</span>
    //                     </div>
    //                   )}
    //                 </>
    //               );
    //             },
    //           },
    {
      Header: "Zone",
      accessor: "",
      Cell: (row) => {
        const [hoveredIndex, setHoveredIndex] = useState(null); // Keep track of which zone is being hovered over

        return (
          <>
            {row.row.original.user_id != null &&
              row.row.original.user_id.zone_id != null &&
              row.row.original.user_id.zone_id != undefined ? (
              <>
                {row.row.original.user_id.zone_id.length > 0 ? (
                  <div className="UserName">
                    <span className="PTAGs">
                      {row.row.original.user_id.zone_id.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.zone_name.length > 10 ? (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)} // Set index on hover
                                onMouseLeave={() => setHoveredIndex(null)} // Remove hover index when not hovering
                                style={{ position: "relative" }} // Ensure relative position for tooltip
                              >
                                {item.zone_name.slice(0, 8)}...
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            ) : (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{ position: "relative" }}
                              >
                                {item.zone_name}
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </span>
                  </div>
                ) : (
                  <div className="UserName PTAGs">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName PTAGs">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    // {
    //     Header: "Client",
    //     accessor: "",
    //     Cell: (row) => {
    //       return (
    //         <>
    //           {row.row.original.client_id != null &&
    //           row.row.original.client_id != undefined &&
    //           row.row.original.client_id.client_name !="" &&
    //           row.row.original.client_id.client_name != undefined ? (
    //             <div className="UserName MobileNumber">
    //               <span

    //               data-tooltip-id="list-ToolTips"
    //               data-tooltip-content={row.row.original.client_id.client_name}

    //               >{row.row.original.client_id.client_name.length > 16 ?

    //             <>
    //             {row.row.original.client_id.client_name.slice(0,14)}..
    //             </>
    //             :
    //             <>{row.row.original.client_id.client_name}</>

    //             }</span>
    //             </div>
    //           ) : (
    //             <div className="UserName MobileNumber">
    //               <span>---</span>
    //             </div>
    //           )}
    //         </>
    //       );
    //     },
    //   },
    // {
    //   Header: "Branch",
    //   accessor: "",
    //   Cell: (row) => {
    //     const [showTooltip, setShowTooltip] = useState(false);

    //     return (
    //       <>
    //         {row.row.original.client_id != null &&
    //         row.row.original.client_id != undefined &&
    //         row.row.original.client_id.client_name != "" &&
    //         row.row.original.client_id.client_name != undefined ? (
    //           <div
    //             className="UserName"
    //             onMouseEnter={() => setShowTooltip(true)}
    //             onMouseLeave={() => setShowTooltip(false)}
    //             style={{ position: "relative", }} // Relative positioning for tooltip placement
    //           >
    //             <span style={{ display: "flex" }}>
    //               {row.row.original.client_id.client_name.length > 12 ? (
    //                 <>
    //                   {row.row.original.client_id.client_name.slice(0, 12)}...
    //                 </>
    //               ) : (
    //                 <>{row.row.original.client_id.client_name}</>
    //               )}
    //             </span>

    //             {/* Custom tooltip */}
    //             {showTooltip && (
    //               <div className="custom-tooltip">
    //                 {row.row.original.client_id.client_name}
    //               </div>
    //             )}
    //           </div>
    //         ) : (
    //           <div className="UserName">
    //             <span>---</span>
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const client = row?.row?.original?.client_id;
        const branchCode = client?.branch_code ?? "";
        const clientName = client?.client_name ?? "";

        // Full label for tooltip
        const fullLabel = branchCode
          ? `${branchCode} - ${clientName}`
          : clientName;

        // Short display (truncate client name only)
        const shortName =
          clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

        const shortLabel = branchCode
          ? `${branchCode} - ${shortName}`
          : shortName;

        return (
          <>
            {client && clientName ? (
              <div
                className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: "relative" }}
              >
                <span>{shortLabel}</span>

                {showTooltip && (
                  <div className="custom-tooltip">{fullLabel}</div>
                )}
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    // oldemplo.old_employee &&
    // {
    //   Header: "Status",
    //   accessor: "",
    //   Cell: (row) => {
    //     if (
    //       row.row.original.user_id !== undefined &&
    //       row.row.original.user_id !== null
    //     ) {
    //       const isActive = row.row.original.user_id.is_active;
    //       const buttonStyle = {
    //         color: isActive ? "green" : "red",

    //       };

    //       return <p className="m-0" style={buttonStyle}>{isActive ? "Active" : "Inactive"}</p>;
    //     }
    //     return "--";
    //   },
    // },
    {
      Header: "Status",
      accessor: "",
      Cell: (row) => {
        const user = row.row.original.user_id;

        if (!user) return "--";

        const isActive = user.is_active;
        const isExited = row.row.original?.is_exited;
        const isExpired = row.row.original?.is_expired;

        if (isExited) {
          return (
            <p className="m-0" style={{ color: "#d9534f", fontWeight: 600 }}>
              Exited
            </p>
          );
        }
        if (isExpired) {
          return (
            <p className="m-0" style={{ color: "#d9534f", fontWeight: 600 }}>
              Expired
            </p>
          );
        }

        return (
          <p className="m-0" style={{ color: isActive ? "green" : "orange" }}>
            {isActive ? "Active" : "Inactive"}
          </p>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        console.log(row.row.original.id, "029340");
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              {Block_request?.black_list != true && (
                <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(row.row.original.user_id.id);
                    setDeletePopup(true);
                  }}
                >
                  <span className="OuterActionSpan">
                    {/* <i
                        class="fa-regular fa-trash-can"
                        style={{
                          fontSize: "15px",
                          paddingRight: "3px",
                          paddingBottom: "3px",
                        }}
                      ></i> */}
                    <span className="EditImages">
                      <img src={DeleteImages} />
                    </span>
                    <span className="ActionsList"> Delete </span>
                  </span>
                </button>
              )}

              {oldemplo.old_employee == true && (
                <button
                  className=" btn Status"
                  component="span"
                  onClick={(e) => {
                    e.stopPropagation();
                    seteditpopup(true);
                    setrecords(row.row.original);
                  }}
                  disabled={row.row.original?.is_exited}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={EditImages} />
                    </span>
                    <span className="ActionsList"> Edit </span>
                  </span>
                </button>
              )}

              {Block_request?.black_list == true && (
                <button
                  className=" btn Status"
                  component="span"
                  onClick={(e) => {
                    e.stopPropagation();
                    Swal.fire({
                      title: "Are you sure you want to unblock this employee?",
                      text: "Please provide your remarks to proceed.",
                      input: "textarea",
                      inputPlaceholder: "Enter remarks here...",
                      inputAttributes: {
                        "aria-label": "Enter remarks here",
                      },
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Yes, Unblock",
                      cancelButtonText: "Cancel",
                      confirmButtonColor: "#234492", // theme color
                      cancelButtonColor: "#6c757d",
                      preConfirm: (remarks) => {
                        if (!remarks || remarks.trim() === "") {
                          Swal.showValidationMessage("Remarks are required!");
                          return false;
                        }
                        return remarks;
                      },
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const remarks = result.value;
                        console.log(
                          "Employee unblocked:",
                          row.row.original,
                          row.row.original.user_id?.id,
                          remarks,
                        );
                        console.log("Remarks:", remarks);
                        const payloads = {
                          form_data: {
                            unblock_reason: remarks,
                            status: "unblocked",
                          },
                          EditId: row.row.original.user_id?.id,
                          Delete_api_calls: {
                            search: search,
                            page_size: 20,
                            page: dtpageindex,
                            old_employee: oldemplo.old_employee,
                            state: datas.state,
                            region: datas.region,
                            zone: datas.zone,
                            client: Client,
                            black_list: Block_request?.black_list,
                            is_reliever: "false",
                          },
                          Call_deleted_: 1,
                        };
                        // ✅ Place your unblock logic here
                        dispatch(resetUnblockActions_opretions(payloads));
                      }
                    });
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={BlockImage} />
                    </span>
                    <span className="ActionsList"> Un block </span>
                  </span>
                </button>
              )}
            </div>
          </>
        );
      },
    },
  ].filter(Boolean);
  //  console.log(oldemplo.old_employee , "29034093248");

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 400),
    [],
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
    // setsearch(e);
  }

  const HandleBlockemployee = (e) => {
    setdtPageindex(1);

    if (e != null) {
      setBlockEMp(e);
      dispatch(settheEmployee_actions_block_request(e));

      setblockrequesr({
        ...Block_request,
        black_list: e.value,
      });
    } else {
      setBlockEMp({ value: "", labe: "" });
      setblockrequesr({
        ...Block_request,
        black_list: "",
      });
      dispatch(settheEmployee_actions_block_request({ value: "", labe: "" }));
    }
  };

  const HandleOldemployee = (e) => {
    setdtPageindex(1);
    setOldEMp(e);
    dispatch(setthe_employeee_actions_forEmployee_filter(e));
    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const HandleSubmits = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        page: dtpageindex,
        GetAPICALL: 2,
        Getapiall: {
          search: search,
          // page_size: dtpagesize,
          page_size: 20,
          page: dtpageindex,
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          client: Client,
          black_list: Block_request?.black_list,
          old_employee: oldemplo.old_employee,
          is_reliever: "false",
        },
      };
      setsearch("");
      dispatch(setUserDeleteActions(payload, setDeletePopup(false)));
    }
  };

  const HandleClientBranches = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      // dispatch(SetTheDashboardClientList(selectedVal));
      dispatch(setTheEmpoyeeAction_branch(selectedVal));
      setClients(selectedVal.value);
    } else if (selectedVal == null) {
      setClients("");

      dispatch(setTheEmpoyeeAction_branch({ value: "", label: "ALL" }));
      // dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        region: selectedVal.value,
      });

      dispatch(settheEmployeeActionRegion(selectedVal));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      dispatch(settheEmployeeActionZone(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheEmpoyeeAction_branch({ value: "", label: "ALL" }));

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState(selectedVal));
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState({ value: "", label: "ALL" }));
      dispatch(settheEmployeeActionRegion({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone({ value: "", label: "ALL" }));
    }
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch);
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("EmployeeActionsPageTableScrollPosition", val);
  };

  return (
    <>
      <div
        onScroll={scrollPosition}
        ref={currentRef}
        className={stateDisplay ? "outterContent" : "inner-Content"}
      >
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Employees </h3>
          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px ",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
            // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                      (item) => item.label === "ALL" || item.label === "All",
                    )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                      multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            // placeholder={
            //   datas.state == ""
            //     ? "without selected state you can't select Region"
            //     : "search"
            // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                      (item) => item.label === "ALL" || item.label === "All",
                    )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                      multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                if (dtpageindex == 1) {
                  HandleClientBranches(e);
                  if (e != null) {
                  }
                }
              }}
              filterOption={() => true}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.EmployeeVerificationsNeed.EmployeeAction_Branch
                  ? Array.isArray(
                    state.EmployeeVerificationsNeed.EmployeeAction_Branch,
                  )
                    ? state.EmployeeVerificationsNeed.EmployeeAction_Branch.some(
                      (item) => item.label === "ALL" || item.label === "All",
                    )
                      ? false
                      : true
                    : state.EmployeeVerificationsNeed.EmployeeAction_Branch
                      .label === "ALL" ||
                      state.EmployeeVerificationsNeed.EmployeeAction_Branch
                        .label === "All"
                      ? false
                      : true
                  : true
              }
              value={state.EmployeeVerificationsNeed.EmployeeAction_Branch}
            />
          </div>
          {/* 
          <div
            className="col-3"
            style={{
              zIndex: "20",
              marginLeft: "-10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "-22px",
            }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed.EmployeeRangeOne == ""
                    ? []
                    : [
                        new Date(
                          state.EmployeeVerificationsNeed.EmployeeRangeOne
                        ),
                        new Date(
                          state.EmployeeVerificationsNeed.EmployeeRangeTwo
                        ),
                      ]
                }
                components={{
                  ClearButton: () => null,
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // onClean={(e) => cleaningrange(e)}

                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    if (diffDays === 30) {
                      // Since we are using inclusive range, difference should be 30 for 31 days
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else if (diffDays < 30) {
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else {
                      toast.error("Please select a range of exactly 31 days.", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }
                }}
              />
            </div>
          </div> */}
        </div>

        <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.ProfileSignatureCalls.ProfileSignatureDatas}
            columns={columns}
            totalItems={state.ProfileSignatureCalls.Total_count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pageindex={pageindex}
            datacount={state.ProfileSignatureCalls.Total_count}
            OldEmployeFilters={true}
            oldemloyeeOptions={oldemloyeeOptions}
            OldEmp={OldEmp}
            Filter={true}
            HandleOldemployee={(e) => {
              HandleOldemployee(e);
            }}
            Block_listed_filter
            Block_lists={Block_lists}
            HandleBlockemployee={(e) => {
              HandleBlockemployee(e);
            }}
            BlockEmp={BlockEmp}
            searchVal={
              TablePositionPersist?.EmployeeActions?.search == "" ||
                TablePositionPersist?.EmployeeActions?.search == undefined
                ? ""
                : TablePositionPersist.EmployeeActions.search
            }
            search_key={true}
          />
        </div>
      </div>

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Employee"}
        />
      ) : null}
      {EditPopup && (
        <Employee_edit
          show={EditPopup}
          setshow={seteditpopup}
          employee={records}
          passingpayloads={{
            search: search,
            page_size: 20,
            page: dtpageindex,
            old_employee: oldemplo.old_employee,
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            client: Client,
          }}
          reliver_calls={false}
        />
      )}
    </>
  );
};

export default EmployeeActions;
